import React, { InputHTMLAttributes } from 'react';
import { Switch } from '@headlessui/react';
import classNames from 'classnames';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

type SimpleToggleTWProps = IHasTestData &
  Omit<InputHTMLAttributes<HTMLButtonElement>, 'onChange' | 'name'> & {
    className?: string;
    text?: string;
    onChange?: (value: boolean) => void;
    labelClassName?: string;
    checked?: boolean;
  };

export const SimpleToggleTW: React.FC<SimpleToggleTWProps> = ({
  checked,
  onChange,
  text,
  className,
  labelClassName,
  readOnly,
  onBlur,
  ...rest
}) => {
  return (
    <Switch.Group as="div" className={classNames('flex items-center', className)}>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={readOnly}
        onBlur={onBlur}
        className={classNames(
          {
            'bg-green-500': checked,
            'bg-gray-200': !checked,
          },
          'relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none'
        )}
        data-test-id={mergeTests(rest['data-test-id'], 'toggle-tailwind')}
      >
        <span
          aria-hidden="true"
          className={classNames(
            {
              'translate-x-5': checked,
              'translate-x-0': !checked,
            },
            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
          )}
          data-test-id={mergeTests(rest['data-test-id'], `${checked}`)}
        />
      </Switch>
      {text && (
        <Switch.Label as="span" className="ml-3 text-sm">
          <span className={classNames('font-medium text-gray-900', labelClassName)}>{text}</span>
        </Switch.Label>
      )}
    </Switch.Group>
  );
};
